/* ============================================================
   KaNi Candy - gezeichnete Platzhalter
   Solange keine Produktfotos hinterlegt sind, zeichnen wir eine Candy-Form.
   Form und Farbe leiten sich aus dem Produkt-Handle ab, damit eine Sorte
   ueberall im Shop gleich aussieht. Sobald ein Foto existiert, gewinnt das Foto.
   ============================================================ */
(function (global) {
  'use strict';

  /* Die Datei wird von mehreren Sections eingebunden. Ohne diese Sperre laeuft
     sie mehrfach, jede Instanz beginnt ihren ID-Zaehler neu, und Gradient-IDs
     tauchen doppelt auf. url(#id) trifft dann immer den ersten Treffer im
     Dokument - liegt der in einem ausgeblendeten Element, verlieren alle
     anderen Formen ihre Fuellung. */
  if (global.KaniArt) return;

  var FORMEN = ['bear', 'bottle', 'ring', 'worm', 'disc', 'cube', 'bean'];
  var TOENE = ['#E23B6B', '#8B4A2B', '#FF9A4D', '#57C24A', '#FF3D7F', '#C08A3E',
               '#5AC8E8', '#2E7FE8', '#7A4A2E', '#9BD44A', '#D82440', '#FF7FB0',
               '#3A3340', '#FFB020', '#8E6FE0', '#4FBF6E'];

  function streuwert(str) {
    var h = 0;
    for (var i = 0; i < String(str).length; i++) h = (h * 31 + String(str).charCodeAt(i)) >>> 0;
    return h;
  }
  function heller(hex, d) {
    var n = parseInt(String(hex || '#888888').slice(1), 16);
    var r = Math.min(255, Math.max(0, (n >> 16) + d));
    var g = Math.min(255, Math.max(0, ((n >> 8) & 255) + d));
    var b = Math.min(255, Math.max(0, (n & 255) + d));
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  /* Zufaelliges Praefix zusaetzlich zum Zaehler: selbst wenn doch einmal eine
     zweite Instanz laufen sollte, koennen sich die IDs nicht ueberschneiden. */
  var praefix = 'ka' + Math.random().toString(36).slice(2, 7) + '-';
  var lauf = 0;
  function zeichne(form, ton) {
    var lo = heller(ton, -38), hi = heller(ton, 52), gid = praefix + (++lauf);
    var f = 'fill="url(#' + gid + ')"';
    var formen = {
      bear: '<circle cx="50" cy="30" r="17" ' + f + '/><circle cx="33" cy="17" r="8" ' + f + '/><circle cx="67" cy="17" r="8" ' + f + '/>' +
            '<rect x="32" y="42" width="36" height="38" rx="15" ' + f + '/>' +
            '<circle cx="24" cy="52" r="10" ' + f + '/><circle cx="76" cy="52" r="10" ' + f + '/>' +
            '<circle cx="36" cy="84" r="11" ' + f + '/><circle cx="64" cy="84" r="11" ' + f + '/>' +
            '<circle cx="44" cy="28" r="2.6" fill="rgba(0,0,0,.42)"/><circle cx="56" cy="28" r="2.6" fill="rgba(0,0,0,.42)"/>',
      bottle: '<rect x="38" y="8" width="24" height="12" rx="4" ' + f + '/><rect x="42" y="18" width="16" height="12" ' + f + '/>' +
              '<rect x="28" y="26" width="44" height="66" rx="16" ' + f + '/>' +
              '<rect x="36" y="38" width="8" height="40" rx="4" fill="rgba(255,255,255,.35)"/>',
      ring: '<circle cx="50" cy="50" r="36" fill="none" stroke="url(#' + gid + ')" stroke-width="22"/>' +
            '<circle cx="50" cy="50" r="36" fill="none" stroke="rgba(255,255,255,.28)" stroke-width="5"/>',
      worm: '<path d="M14 74c0-18 22-10 22-26S16 30 20 18" fill="none" stroke="url(#' + gid + ')" stroke-width="20" stroke-linecap="round"/>' +
            '<path d="M52 84c0-18 22-10 22-26S58 40 62 26" fill="none" stroke="url(#' + gid + ')" stroke-width="20" stroke-linecap="round"/>',
      disc: '<circle cx="50" cy="50" r="40" ' + f + '/>' +
            '<path d="M50 50a10 10 0 1 1 10-10 22 22 0 1 1-22 22 34 34 0 1 0 34-34" fill="none" stroke="rgba(255,255,255,.62)" stroke-width="8" stroke-linecap="round"/>',
      cube: '<rect x="16" y="16" width="68" height="68" rx="16" ' + f + '/>' +
            '<rect x="26" y="26" width="22" height="10" rx="5" fill="rgba(255,255,255,.36)"/>',
      bean: '<ellipse cx="50" cy="50" rx="42" ry="30" ' + f + ' transform="rotate(-18 50 50)"/>' +
            '<ellipse cx="36" cy="38" rx="12" ry="6" fill="rgba(255,255,255,.4)" transform="rotate(-18 36 38)"/>'
    };
    return '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="' + hi + '"/><stop offset="1" stop-color="' + lo + '"/></linearGradient></defs>' +
      (formen[form] || formen.bean) + '</svg>';
  }

  /* Verpackungen brauchen einen Gefaess-Umriss, keine Suessigkeit. Ein Bonbon
     auf der Kachel "Glas" fuehrt in die Irre. */
  function gefaessSVG(art) {
    var attr = 'fill="rgba(255,255,255,.07)" stroke="currentColor" stroke-width="4" ' +
               'stroke-linejoin="round" stroke-linecap="round"';
    var formen = {
      bag: '<path d="M12 12h36l6 6v54H6V18z" ' + attr + '/>' +
           '<path d="M12 12 16 4h28l4 8" ' + attr + '/>',
      tin: '<rect x="8" y="14" width="44" height="58" rx="10" ' + attr + '/>' +
           '<rect x="4" y="5" width="52" height="12" rx="5" ' + attr + '/>',
      jar: '<path d="M10 30c0-8 6-10 6-14v-2h28v2c0 4 6 6 6 14v34a8 8 0 0 1-8 8H18a8 8 0 0 1-8-8z" ' + attr + '/>' +
           '<rect x="16" y="4" width="28" height="9" rx="4" ' + attr + '/>'
    };
    return '<svg viewBox="0 0 60 78" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      (formen[art] || formen.jar) + '</svg>';
  }

  var KaniArt = {
    /* >>> statt >>: der vorzeichenbehaftete Shift liefert bei Streuwerten ueber
       2^31 negative Indizes und damit undefined. */
    svg: function (handle) {
      var h = streuwert(handle || 'kani');
      return zeichne(FORMEN[h % FORMEN.length], TOENE[(h >>> 3) % TOENE.length]);
    },
    gefaess: gefaessSVG,
    /* Fuellt alle noch leeren [data-kani-art]-Elemente im Dokument. */
    fuellen: function (wurzel) {
      var els = (wurzel || document).querySelectorAll('[data-kani-art]:empty');
      Array.prototype.forEach.call(els, function (el) {
        el.innerHTML = KaniArt.svg(el.getAttribute('data-kani-art'));
      });
    }
  };

  global.KaniArt = KaniArt;

  function start() { KaniArt.fuellen(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(window);
